import React from 'react';
import AdminPersonnelModal, {
  ModalFormSection,
  ModalFormGroup,
  ModalFooterActions
} from '../ui/AdminPersonnelModal';
import AffiliationSelect from '../../companies/AffiliationSelect';
import CompanyCitySelect from '../../companies/CompanyCitySelect';
import '../../companies/AffiliationBadge.css';

const FORM_ID = 'ap-company-form';

const CompanyFormModal = ({
  show,
  onHide,
  formData,
  onChange,
  onSubmit,
  editingCompany,
  affiliations = [],
  defaultAffiliation = null,
  affiliationsLoading = false,
  onReloadAffiliations,
  affiliationsError = '',
  cities = [],
  defaultCity = null,
  citiesLoading = false,
  onReloadCities,
  citiesError = ''
}) => {
  const isEdit = Boolean(editingCompany);

  return (
    <AdminPersonnelModal
      show={show}
      onHide={onHide}
      size="lg"
      icon="building"
      badge={isEdit ? 'Modification' : 'Nouveau'}
      title={isEdit ? 'Modifier la société' : 'Ajouter une société'}
      subtitle="Informations de la société affiliée au SMIE"
      ariaLabelledBy="ap-company-form-title"
      footer={
        <ModalFooterActions
          onCancel={onHide}
          primary={
            <button type="submit" form={FORM_ID} className="ap-modal-btn ap-modal-btn--primary">
              {isEdit ? 'Enregistrer' : 'Créer la société'}
            </button>
          }
        />
      }
    >
      <form id={FORM_ID} className="ap-modal-form" onSubmit={onSubmit}>
        <ModalFormSection title="Affiliation SMIE">
          <ModalFormGroup label="Organisme affilié" required fullWidth htmlFor="co-affiliation">
            <AffiliationSelect
              id="co-affiliation"
              name="affiliation_id"
              value={formData.affiliation_id}
              affiliations={affiliations}
              defaultAffiliation={defaultAffiliation}
              loading={affiliationsLoading}
              onReloadAffiliations={onReloadAffiliations}
              loadError={affiliationsError}
              onChange={onChange}
            />
          </ModalFormGroup>
        </ModalFormSection>

        <ModalFormSection title="Identification">
          <div className="ap-modal-form__grid">
            <ModalFormGroup label="Code société" required htmlFor="co-company-code">
              <input
                id="co-company-code"
                type="text"
                name="company_code"
                className="ap-modal-input"
                value={formData.company_code}
                onChange={onChange}
                placeholder="FT001"
                maxLength={32}
                required
                autoFocus
              />
            </ModalFormGroup>
            <ModalFormGroup label="Nom de la société" required htmlFor="co-name">
              <input
                id="co-name"
                type="text"
                name="name"
                className="ap-modal-input"
                value={formData.name}
                onChange={onChange}
                placeholder="FUNTOA SMIE"
                required
              />
            </ModalFormGroup>
            <ModalFormGroup label="Adresse" fullWidth htmlFor="co-address">
              <input
                id="co-address"
                type="text"
                name="address"
                className="ap-modal-input"
                value={formData.address}
                onChange={onChange}
                placeholder="Adresse complète"
              />
            </ModalFormGroup>
          </div>
        </ModalFormSection>

        <ModalFormSection title="Contact">
          <div className="ap-modal-form__grid">
            <ModalFormGroup label="Ville" htmlFor="co-city">
              <CompanyCitySelect
                id="co-city"
                name="city_id"
                className="ap-modal-input co-aff-select"
                value={formData.city_id}
                cities={cities}
                defaultCity={defaultCity}
                loading={citiesLoading}
                onReloadCities={onReloadCities}
                loadError={citiesError}
                onChange={onChange}
              />
            </ModalFormGroup>
            <ModalFormGroup label="Téléphone" htmlFor="co-phone">
              <input
                id="co-phone"
                type="tel"
                name="phone"
                className="ap-modal-input"
                value={formData.phone}
                onChange={onChange}
                placeholder="+261 …"
              />
            </ModalFormGroup>
            <ModalFormGroup label="Email" fullWidth htmlFor="co-mail">
              <input
                id="co-mail"
                type="email"
                name="mail"
                className="ap-modal-input"
                value={formData.mail}
                onChange={onChange}
                placeholder="contact@societe.mg"
              />
            </ModalFormGroup>
          </div>
        </ModalFormSection>
      </form>
    </AdminPersonnelModal>
  );
};

export default CompanyFormModal;
